import { useEffect, useState } from "react";

import { Dialog } from "@mui/material";
import WidgetsPage from "./index";

export default function WidgetsDialogs({
    open,
    onClose,
    table,
    order,
    onInvoiceClose,
    isTakeaway,
}) {
    const [mode, setMode] = useState(false);

    const handleNext = () => {
        setMode(1);
    };

    const handleBack = () => {
        setMode(0);
    };

    const handleDivideOnConfirm = (totalPayload) => {
        handleNext();
    };

    const handleChooseOrderItemDialogClose = () => {
        if (onClose) onClose();
        setMode(0);
    };

    const handleInvoiceClosed = () => {
        if (onInvoiceClose) onInvoiceClose();

        setMode(0);
    };

    return (
        <>
            <Dialog
                open={open}
                PaperProps={mode == 1 ? { sx: { width: "100%" } } : {}}
                onClose={handleChooseOrderItemDialogClose}
            >
                <WidgetsPage
                    mode={mode}
                    handleNext={handleDivideOnConfirm}
                    backCallback={handleBack}
                    table={table}
                    order={order}
                    handleInvoiceClosed={handleInvoiceClosed}
                    isTakeaway={isTakeaway}
                ></WidgetsPage>
            </Dialog>
        </>
    );
}
